import React, {Component} from 'react';
import TrackingToolsToolBar from '../components/TrackingToolsToolBar/TrackingToolsToolBar';
import Carousel from '../components/Carousel/Carousel';
import BlankComponent from '../components/BlankComponent/BlankComponent';
import Skeleton from "../components/Skeleton/Skeleton";
import connect from "react-redux/es/connect/connect";
import {REQUEST_NEWS_DATA} from "../actions/newsActions";
import {REQUEST_SHIPPING_ADVISORY_DATA} from "../actions/shippingAdvisoryActions";
import NewsWidget from "../components/NewsWidget/NewsWidget";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import moment from "moment";
import { NavLink } from 'react-router-dom';
import {REQUEST_SITEMAP_DATA} from "../actions/sitemapActions";

const mapStateToProps = (state) => {
  return {
    newsData: state.newsData,
    shippingAdvisoryData: state.shippingAdvisoryData,
      sitemapData: state.sitemapData
  };
};

const mapDispatchToProps = dispatch => ({
  getNewsData: () => dispatch({type: REQUEST_NEWS_DATA}),
  getShippingAdvisoryData: () => dispatch({type: REQUEST_SHIPPING_ADVISORY_DATA}),
    getSitemapData: () => dispatch({type: REQUEST_SITEMAP_DATA})
});

class Home extends Component {

  componentDidMount() {
    if (!Object.keys(this.props.newsData).length) {
      this.props.getNewsData();
    }
    if (!Object.keys(this.props.shippingAdvisoryData).length) {
      this.props.getShippingAdvisoryData();
    }
      if (!this.props.sitemapData.sitemap) {
          this.props.getSitemapData();
      }
  };

  getLatestAdvisory() {

    let dateString = null;

    if (Object.keys(this.props.shippingAdvisoryData).length && this.props.shippingAdvisoryData.advisories.length > 0) {
      dateString = this.props.shippingAdvisoryData.advisories.sort((item1, item2) => {
        let date1 = moment(item1);
        let date2 = moment(item2);

        return date1.isBefore(date2);
      })[0].date;

      return moment(dateString).format("MMM. D, YYYY.");
    }

  }

  render() {

    let advisoryDate = this.getLatestAdvisory();

    return (
      <BlankComponent>
        <div className="wide-wrapper">
          <Carousel/>
        </div>
        <div className="wide-wrapper">
          <div className={Object.keys(this.props.shippingAdvisoryData).length && this.props.shippingAdvisoryData.advisories.length > 0 ? "home-shipping-advisory__container" : "hidden"}>
            {
              advisoryDate ? (
                <NavLink className="shipping-advisory-widget icon-next" to="/shipping-advisory">
                    <img className="home-shipping-advisory__icon" src="./assets/icons/alert-blue.svg"
                         alt="Shipping Alert"/>
                      <span className="home-shipping-advisory__as-of">New shipping advisory as of <span className="home-shipping-advisory__date">{advisoryDate}</span></span>
                </NavLink>
              ) : <Skeleton type="MAIN_PANEL"/>
            }
          </div>
        </div>
        <div className="wide-wrapper">
          <TrackingToolsToolBar
            showToolsLabel={true}
            activeTool='tracking'
            showTrackShipmet={true}
            showFlightScheduleSearch={true}
            showOnlineBooking={true}
            showRapidRewards={true}
            showTrackAirWayBill={false}
            showAdvancedSearch={false}
            addEmailNotiSignUp = {true}
          />
        </div>
        {/* start wide-wrapper */}
        <div className="wide-wrapper">
          {/*start home-cards-container*/}
          <ContentPanel
            skeleton={<Skeleton type="SHORT_CONTENT"/>}
            errorTemplate={<Skeleton type="SHORT_CONTENT_ERROR"/>}
            templateUrl="./content/home/page-components/promotion/promotion.html"
          />
          {/*end home-cards-container*/}
          {/* start basic-two-columns */}
          <div className="basic-two-columns">
            {/*start basic-two-columns__wrapper*/}
            <div className="basic-two-columns__wrapper">
              {/*start basic-two-columns__row*/}
              <div className="basic-two-columns__row">
                {/*start basic-two-columns__column*/}
                <ContentPanel
                  skeleton={<Skeleton type="SHORT_CONTENT"/>}
                  errorTemplate={<Skeleton type="SHORT_CONTENT_ERROR"/>}
                  templateUrl="./content/home/page-components/content-detail/left-bottom-tile.html"
                />
                {/*end basic-two-columns__column*/}
                {/*start basic-two-columns__column*/}
                <div className="basic-two-columns__column prn">
                  <div className="basic-two-columns__feed basic-two-columns__feed--news">
                    <h2 className="basic-two-columns__feed-title color-primary-blue">News</h2>
                    {
                      Object.keys(this.props.newsData).length ? (
                        <NewsWidget news={this.props.newsData.news}/>
                      ) : <Skeleton type="MAIN_PANEL"/>
                    }
                  </div>
                </div>
                {/*end basic-two-columns__column*/}
              </div>
              {/*end basic-two-columns__row*/}
            </div>
            {/*end basic-two-columns__wrapper*/}
          </div>
          {/* end basic-two-columns */}

        </div>
        {/* end wide-wrapper */}
      </BlankComponent>
    )
  }
};

export default (connect(mapStateToProps, mapDispatchToProps)(Home));



// WEBPACK FOOTER //
// ./src/pages/Home.js